import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
import { useFileBrowserContext } from 'app/domains/filesystem';
import { AlertContainer } from './styled';
export function FolderPermissionWarning() {
    const { folderPermission } = useFileBrowserContext();
    const { accessLevel } = folderPermission;
    const isRestricted = accessLevel !== 'full';
    if (isRestricted) {
        return (<AlertContainer>
        <Alert appearance="warning" title={t({
                message: 'Missing access',
                comment: 'Alert title - folder picker when lacking permission to write',
            })} message={t({
                message: "You don't have access to this folder. You can only see the files you have direct access to.",
                comment: 'Alert body - folder picker when lacking permission to write',
            })}/>
      </AlertContainer>);
    }
    return null;
}
